// extracted by mini-css-extract-plugin
export default {"detailsStepContainer":"revN0L"};